import React from 'react';
import { usePortfolio } from '../../context/PortfolioContext';
import { Experience } from '../../domain/Experience';
import { GraduationCap, Calendar, CheckCircle2, ExternalLink } from 'lucide-react';

export const ExperienceTimeline: React.FC = () => {
  const { experiences } = usePortfolio();

  return (
    <section id="experience" className="experience" style={{ background: 'var(--bg-glass)' }}>
      <div className="container">
        <div className="section-title-wrap">
          <div className="section-tag">
            <GraduationCap size={14} />
            <span>Academic & Career Path</span>
          </div>
          <h2 className="section-title">
            Education & <span>Experience</span>
          </h2>
          <p className="section-subtitle">
            Solid academic foundation from Tagoloan Community College supplemented by hands-on IT technical support and administrative experience.
          </p>
        </div>

        <div className="timeline">
          {experiences.map((exp: Experience) => (
            <div key={exp.id} className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '0.6rem' }}>
                  <span className="timeline-date">
                    <Calendar size={14} style={{ display: 'inline', marginRight: '4px', verticalAlign: '-2px' }} />
                    {exp.period}
                  </span>
                  <span className="section-tag" style={{ fontSize: '0.75rem', padding: '0.2rem 0.6rem', marginBottom: 0 }}>
                    {exp.getTypeBadge()}
                  </span>
                </div>

                <h3 className="timeline-title">{exp.title}</h3>
                <h4 className="timeline-org">{exp.organization}</h4>

                <p className="timeline-desc" style={{ marginBottom: '1rem', lineHeight: '1.6' }}>
                  {exp.description}
                </p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.45rem', marginBottom: exp.link ? '1.2rem' : '0' }}>
                  {exp.achievements.map((ach, idx) => (
                    <div key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', fontSize: '0.85rem', color: 'var(--text-main)', lineHeight: '1.5' }}>
                      <CheckCircle2 size={15} color="var(--accent-cyan)" style={{ flexShrink: 0, marginTop: '3px' }} />
                      <span>{ach}</span>
                    </div>
                  ))}
                </div>

                {exp.link && (
                  <div style={{ marginTop: '1rem' }}>
                    <a
                      href={exp.link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-secondary"
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        fontSize: '0.82rem',
                        padding: '0.45rem 0.9rem',
                        borderRadius: 'var(--radius-sm)',
                        background: 'rgba(0, 242, 254, 0.08)',
                        borderColor: 'rgba(0, 242, 254, 0.3)',
                        color: 'var(--accent-cyan)'
                      }}
                    >
                      <ExternalLink size={14} />
                      <span>{exp.link.text}</span>
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
